import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from '@/views/NotFound.vue';
import SignPdf from '@/views/SignPdf.vue';
import Maximizer from '@/views/Maximizer.vue';
import SignPdfView from '@/views/SignPdfView.vue';
import SignPdfAdmin from '@/views/SignPdfAdmin.vue'
import Invoice from '@/views/Invoice.vue';
import PasswordSet from '@/views/PasswordSet.vue';
import SignUp from '@/views/SignUp.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/maximizer',
    name: 'Maximizer',
    component: Maximizer
  },
  {
    path: '/sign-pdf',
    name: 'SignPdf',
    component: SignPdf
  },
  {
    path: '/sign-pdf/view',
    name: 'SignPdfView',
    component: SignPdfView
  },
  {
    path: '/sign-pdf/admin',
    name: 'SignPdfAdmin',
    component: SignPdfAdmin
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice
  },
  {
    path: '/set-password',
    name: 'PasswordSet',
    component: PasswordSet,
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp,
    meta: {
      title: 'Sign Up'
    }
  },
  {
    path: '/*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
